import React from 'react'

interface ChatHistoryOnIconProps {
  size?: number
  color?: string
  className?: string
}

export const ChatHistoryOnIcon: React.FC<ChatHistoryOnIconProps> = ({
  size = 32,
  color = '#FFFFFF',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_300_4184)">
        <rect
          width="32"
          height="32"
          rx="16"
          transform="matrix(1 0 0 -1 0 32)"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7ZM16 8.2002C11.6922 8.2002 8.2002 11.6922 8.2002 16C8.2002 20.3078 11.6922 23.7998 16 23.7998C20.3078 23.7998 23.7998 20.3078 23.7998 16C23.7998 11.6922 20.3078 8.2002 16 8.2002ZM15.9932 11.9004C16.3241 11.9006 16.5922 12.1682 16.5928 12.499V15.2354L20.0254 16.4336L20.1357 16.4854C20.3753 16.6282 20.4898 16.9236 20.3945 17.1973C20.299 17.4708 20.0254 17.6318 19.749 17.5947L19.6309 17.5664L15.7949 16.2275C15.5542 16.1434 15.3927 15.9161 15.3926 15.6611V12.499C15.3931 12.1681 15.6621 11.9004 15.9932 11.9004Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_300_4184">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatHistoryOnIcon
